module.exports = __webpack_public_path__ + "fonts/iconfont.ac9d3e6e.ttf";